import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Son = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 81.74 80.37">
  <G fill={color}>
    <Path d="M0,25.13v30.1c0,2.47,2,4.48,4.48,4.48h10.64V20.66H4.48c-2.47,0-4.48,2-4.48,4.48Z"/>
    <Path d="M55.29.57c-1.41-.79-3.15-.75-4.53.1l-26.7,16.45v46.13l26.7,16.45c.72.44,1.53.67,2.35.67.75,0,1.5-.19,2.18-.57,1.42-.79,2.29-2.29,2.29-3.91V4.47c0-1.62-.88-3.12-2.29-3.91Z"/>
    <Path d="M70.58,19.04c-2.1-1.31-4.86-.66-6.16,1.43-1.31,2.1-.66,4.86,1.43,6.16,4.34,2.7,6.94,7.36,6.94,12.47s-2.59,9.76-6.94,12.47c-2.1,1.31-2.74,4.07-1.43,6.16.85,1.36,2.31,2.11,3.8,2.11.81,0,1.62-.22,2.36-.68,6.99-4.35,11.16-11.85,11.16-20.06s-4.17-15.72-11.16-20.06Z"/>
  </G>
</Svg>
);
};

export default Son;
